/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_PICOS_AUDIT_STATS_TABLE = gql`
  query StorePicosStatsTable($input: StorePicOSStatsTableInput!) {
    storePicosStatsTable(input: $input) {
      hasMore
      count
      results {
        auditDate
        executeDenom
        executeNum
        sellDenom
        sellNum
        averageCompliance
        numDisplaysWithOos
        correctPricingPercentage
      }
    }
  }
`
